/**
 * ScienceVariant — reuses the existing <ScienceBackdrop /> molecule
 * field and overlays the approved slogan copy with a staggered fade-in.
 * Purple/indigo science-lab aesthetic.
 */
import { motion } from "framer-motion";
import ScienceBackdrop from "@/components/ScienceBackdrop";
import Wordmark from "./Wordmark";
import { COPY } from "./copy";

export default function ScienceVariant({ portrait }) {
  const wrap = portrait ? "px-12" : "px-16";
  const headlineSize = portrait ? "text-[130px]" : "text-[110px]";
  const bodyMax = portrait ? "max-w-[900px]" : "max-w-[820px]";

  return (
    <div className="relative w-full h-full overflow-hidden">
      <ScienceBackdrop />
      <div className={`absolute inset-0 flex flex-col items-center justify-center text-center text-white ${wrap}`}>
        <Wordmark
          size={portrait ? "xl" : "lg"}
          glpColor="#FFFFFF"
          floClass="bg-gradient-to-r from-purple-300 via-pink-300 to-fuchsia-300 bg-clip-text text-transparent"
          delay={0.15}
        />
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.8, ease: "easeOut" }}
          className={`${headlineSize} font-extrabold leading-[0.92] tracking-tight mt-6`}
        >
          {COPY.headline1}
          <br />
          <span className="bg-gradient-to-r from-purple-300 via-pink-300 to-fuchsia-300 bg-clip-text text-transparent">
            {COPY.headline2}
          </span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.6, duration: 0.6 }}
          className="text-3xl text-purple-100/90 mt-6 font-medium"
        >
          {COPY.sub}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 2.1, duration: 0.7 }}
          className={`mt-8 ${bodyMax} space-y-2`}
        >
          <p className="text-xl text-white font-semibold">{COPY.body1}</p>
          <p className="text-lg text-purple-100/85">{COPY.body2}</p>
          <p className="text-base text-purple-100/75">{COPY.body3}</p>
        </motion.div>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 3.0, duration: 0.5 }}
          className="absolute bottom-12 text-sm tracking-[0.3em] uppercase text-purple-200/80"
        >
          {COPY.footer} · <span className="text-pink-300 font-bold">{COPY.url}</span>
        </motion.p>
      </div>
    </div>
  );
}
